import IDoctorProfile from "../interfaces/doctor/IDoctorProfile"
import { Themes } from "../constants"
import { isNil } from "lodash"

export const setItem = (key: string, item: any) => {
	const localStorageString = JSON.stringify(item)
	try {
		localStorage.setItem(key, localStorageString)
	} catch (e) {
		console.error(e)
	}
}
export const getItems = (key: string) => {
	if (key) {
		const lsItem = localStorage.getItem(key)
		return JSON.parse(lsItem as string)
	}
	return null
}

export const remove = (keys: string[]) => {
	;(keys || []).forEach((key: string) => {
		localStorage.removeItem(key)
	})
}

export const clearStorage = () => {
	const doctorProfile = localStorage.getItem("doctorProfile")
	localStorage.clear()
	localStorage.setItem("doctorProfile", JSON.stringify(doctorProfile))
}

export const setOpenedDoctorProfileForAdmin = (doctorProfile?: IDoctorProfile) => {
	localStorage.setItem("doctorProfile", doctorProfile ? JSON.stringify(doctorProfile) : "")
}
export const getOpenedDoctorProfileForAdmin = (): IDoctorProfile | null => {
	return JSON.parse(localStorage.getItem("doctorProfile") || null)
}

export const setThemeValue = (theme: Themes) => {
	localStorage.setItem("theme", theme)
}
export const getThemeValue = (): Themes => {
	return localStorage.getItem("theme") as Themes
}
